import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { LogisticService, UnitItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-sub-operation',
  templateUrl: './sub-operation.component.html',
  styleUrls: ['./sub-operation.component.css']
})
export class SubOperationComponent implements OnInit {
    operationId;

    subOperationKeyno;

    public subOperationNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'suboperationlang', gotoParms: () => this.edit!.suboperation_keyno ?? '' }];

    public edit?: Edit;

    public selectListOnlyTimeUnits: UnitItem[] = [];

    public selectListAllUnits: UnitItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.operationId = this.stateService.getStateParams()['operation_id'];
        this.subOperationKeyno = this.stateService.getStateParams()['suboperation_keyno'];
    }

    private async loadEdit() {
        if (!!this.operationId && !!this.subOperationKeyno) {
            this.edit = (await this.datatask.Post(2463, {
                operation_id: this.operationId,
                suboperation_keyno: this.subOperationKeyno
            }))[0];
        }
    }

    private async loadTimeUnits() {
        this.selectListOnlyTimeUnits = await this.logistic.getUnitList({
            onlytimeunits: '1',
            isactive: '1',
            fullname: '1'
        });
    }

    private async loadAllUnits() {
        this.selectListAllUnits = await this.logistic.getUnitList({
            onlytimeunits: '0',
            isactive: '1',
            fullname: '1'
        });
    }

    private async calculateChanges() {
        if (!this.edit) return;

        if (this.edit.help_speed !== '0.00' || this.edit.help_quantity !== '0.00') {
            const response = (await this.datatask.Post(2464, this.edit))[0];

            this.edit.std_time = response?.std_time;
            this.edit.help_speed_helptext = response?.help_speed_helptext;
            this.edit.help_quantity_helptext = response?.help_quantity_helptext;
        } else {
            const response = (await this.datatask.Post(2464, this.edit))[0];

            this.edit.std_time = response?.std_time;
            this.edit.help_speed_helptext = response?.help_speed_helptext;
            this.edit.help_quantity_helptext = response?.help_quantity_helptext;
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2465, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2466, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public onBlur(id: string) {
        if (!this.edit) return;

        switch (id) {
            case 'help_speed':
            case 'help_quantity':
                this.calculateChanges();
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'use_helpunit':
            case 'help_time_unit_no':
            case 'help_quantity_unit_no':
            case 'std_time_unit_no':
                this.calculateChanges();
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadEdit();
        this.loadTimeUnits();
        this.loadAllUnits();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    suboperation_keyno: string;
    operation_id: string;
    operation_name: string;
    std_time_unit_no: string;
    std_time: string;
    note: string;
    help_time_unit_no: string;
    help_quantity: string;
    help_quantity_unit_no: string;
    help_speed: string;
    suboperation_name: string;
    suboperation_id: string;
    use_helpunit: string;
    std_time_seperator_text: string;
    help_seperator_text: string;
    help_speed_helptext: string;
    help_quantity_helptext: string;
}
